import { FlexWrapper, GapView, ParentDiv } from '../../styles/WrapperStyles'
import { React, useState, useRef, useEffect } from 'react'
import { styled, css } from 'styled-components'
import urls from "../../api/urls.json";
import Loader from "../Loader";
import { ImageDivFeedParent, ImageDivFeed, RotatImageIcon } from '../../styles/ImageWrapper';
import placeholder_image from '../../assests/placeholder_image.png'
import chrome_icon from '../../assests/chrome_icon.png';
import rotate_right from '../../assests/rotate_right.png'
import { CommonTextStyle } from '../../styles/TextStyles';
import previous_inctive from '../../assests/arrow_back_grey.png';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import EmptyView from '../EmptyView';
import FeedDetailedProfileView from './FeedDetailedProfileView';
import { BaseButton, BaseButton2 } from '../../styles/ButtonStyles';
import { authorizedHttpGet, authorizedHttpPost } from '../../api/httpCalls';
import PageModal from "../modals/PageModal";
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import '../styles/Verified.css'


const ProfileItemWrapper = styled(FlexWrapper)`
  margin-top: 15px;
`;

const BottomBarWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`;

const NameWrapper = styled.div`
  margin-left: 20px;
  margin-top: 50px;
`;

const GenderView = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 27.5px;
  background-color: #ec4655;
  margin-top: 40px;
  ${props =>
        props.male &&
        css`
      background-color: #50b3c5;
    `}
`;

const SelectedView = styled.button`
  width: 55px;
  height: 55px;
  border-radius: 27.5px;
  border: solid 5px #484848;
  color: #ffffff;
  background-color: #ffffff;
  margin-top: 20px;
  font-size: 20px;
  ${props =>
        props.selected &&
        css`
      background-color: #484848;
    `}
`;

const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;


const ChromeImageParent = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 35px;
  position: absolute;
  cursor: pointer;
  visibility: hidden;
  top: 85%;
  left: 3%;
  ${ImageDivFeedParent}:hover & {
    visibility: visible;
  }
`;

const HeaderWrapper = styled(FlexWrapper)`
    // display: inline;
    margin-left: 200px;
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

const HeaderTextView = styled.span`
    font-family:'Gilory-Semi';
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #d7d7d7;
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `}
    ${props =>
        props.selected &&
        css`
        color: #767676;
        font-family: 'Gilory-Bold';
      `}
    ${props =>
        props.cursor &&
        css`
        cursor: pointer;
      `}
`;

function Verified() {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const [apiPageChange, setApiPageChange] = useState(1);
    const [isLoading, setIsLoading] = useState(false)
    const [isDetailedView, setIsDetailedView] = useState(false);
    const totalPagesApi = useRef(0);
    const totalProfiles = useRef(0);
    const [profiles, setProfiles] = useState([]);
    const [currentTab, setCurrentTab] = useState('M');
    const [approveProfiles, setApproveProfiles] = useState([]);
    const [disapproveProfiles, setDisapproveProfiles] = useState([]);
    const [banProfiles, setBanProfiles] = useState([]);
    const [togglePageModal, setTogglePageModal] = useState(false);
    const defaultParams = {
        gender: "Male",
        profile_state: "approved",
        page: apiPageChange
    }

    const resetState = () => {
        setApproveProfiles([])
        setDisapproveProfiles([])
        setBanProfiles([])
    }

    const handleLeftNavAppChange = (name) => {
        setAppName(name)
        resetState()
    };

    const goToPage = (pageModalNumber) => {
        setTogglePageModal(false);
        if (pageModalNumber > totalPagesApi.current) {
            alert("Page number is greater than total pages");
        } else {
            setApiPageChange(pageModalNumber);
        }
    }

    const getParams = () => {
        if (currentTab === "M") {
            return defaultParams
        } else if (currentTab === 'm') {
            return {
                gender: "Male", profile_state: "disapproved", page: apiPageChange
            }
        } else if (currentTab === 'F') {
            return {
                gender: "Female", profile_state: "approved", page: apiPageChange
            }
        } else {
            return {
                gender: "Female", profile_state: "disapproved", page: apiPageChange
            }
        }
    };

    const getUsers = async () => {
        setIsLoading(true)
        let response = await authorizedHttpGet(urls.GET_VERIFIED, getParams());
        if (response.status) {
            setProfiles(response.data.profiles)
            if (response.data.profiles.length > 0) {
                const refValues = [];
                for (let i = 0; i < response.data.profiles.length; i++) {
                    refValues.push(response.data.profiles[i].ref);
                }
                setApproveProfiles(refValues);
            }

            totalPagesApi.current = response.data.total_pages
            totalProfiles.current = response.data.total_profiles
        }
        setIsLoading(false)
    }

    const handleSelectAction = (ref) => {
        if (disapproveProfiles.includes(ref)) {
            setDisapproveProfiles(disapproveProfiles.filter(item => item !== ref))
            setApproveProfiles([...approveProfiles, ref])

        } else if (approveProfiles.includes(ref)) {
            setApproveProfiles(approveProfiles.filter(item => item !== ref))
            setDisapproveProfiles([...disapproveProfiles, ref])
        }
        else if (banProfiles.includes(ref)) {
            setBanProfiles(banProfiles.filter(item => item !== ref))
            setDisapproveProfiles([...disapproveProfiles, ref])
        }
    }

    const handleBanAction = (ref) => {
        if (banProfiles.includes(ref)) {
            setBanProfiles(banProfiles.filter(item => item !== ref))
            setApproveProfiles([...approveProfiles, ref])
            setDisapproveProfiles(disapproveProfiles.filter(item => item !== ref))
        } else {
            setBanProfiles([...banProfiles, ref])
            setApproveProfiles(approveProfiles.filter(item => item !== ref))
            setDisapproveProfiles(disapproveProfiles.filter(item => item !== ref))
        }
    }

    const saveResults = async () => {
        setIsLoading(true)
        let data = getParams();
        data.approve = approveProfiles;
        data.disapprove = disapproveProfiles;
        data.ban = banProfiles;

        let response = await authorizedHttpPost(urls.POST_VERIFIED, data);
        if (response.status) {
            setApproveProfiles([])
            setDisapproveProfiles([])
            setBanProfiles([])
            await getUsers()
        }
        setIsLoading(false)
    }

    const handleDetailedView = (ref) => {
        setIsDetailedView(true)
        localStorage.setItem('detailViewRef', ref)
    }

    const closeDetailedView = () => {
        setIsDetailedView(false)
        localStorage.removeItem('detailViewRef')
    }

    useEffect(() => {
        closeDetailedView()
        setApiPageChange(1)
    }, [appName])



    useEffect(() => {
        getUsers()
        resetState()
    }, [apiPageChange, appName, currentTab]);


    const openGoogleImages = (imageUrl) => {
        navigator.clipboard.writeText(imageUrl);
        window.open('https://www.google.com/imghp', '_blank');
    }


    return (
        <div className='App'>
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Verified'} />
            {isLoading && <Loader />}
            {
                isDetailedView ? (<FeedDetailedProfileView closeDetailedView={closeDetailedView} />) :
                    <>
                        <ParentDiv>
                            {togglePageModal && <PageModal goToPage={goToPage} page={apiPageChange} closeModal={() => setTogglePageModal(false)} />}
                            <FlexWrapper className='marginTop25'>
                                <HeaderWrapper className='cursorPointer' onClick={() => setTogglePageModal(true)}>
                                    <HeaderSelected>{apiPageChange}</HeaderSelected>
                                    <HeaderSelected className='marginLeft10'>{totalPagesApi.current}</HeaderSelected>
                                    <HeaderSelected className='marginLeft10'>{totalProfiles.current}</HeaderSelected>
                                </HeaderWrapper>
                                <HeaderWrapper>
                                    <HeaderTextView selected={currentTab === 'M'} marginRight cursor onClick={() => setCurrentTab('M')}>M</HeaderTextView>
                                    <HeaderTextView selected={currentTab === 'm'} marginRight cursor onClick={() => setCurrentTab('m')}>m</HeaderTextView>
                                    <HeaderTextView selected={currentTab === 'F'} marginRight cursor onClick={() => setCurrentTab('F')}>F</HeaderTextView>
                                    <HeaderTextView selected={currentTab === 'f'} marginRight cursor onClick={() => setCurrentTab('f')}>f</HeaderTextView>
                                </HeaderWrapper>
                            </FlexWrapper>

                        </ParentDiv>
                        {
                            profiles.length > 0 ? (
                                <>
                                    <GapView height="30px" />
                                    <div className='profileMainDiv'>

                                        {profiles.map((profile, pos) => {
                                            return (
                                                <ProfileItemWrapper key={profile.ref}>
                                                    <div className='displayFlex'>
                                                        {
                                                            profile.photos.map((photo, i) => {
                                                                return (
                                                                    <ImageDivFeedParent
                                                                        rectangle={false}
                                                                        key={photo.photo + i}
                                                                    >
                                                                        <ImageDivFeed
                                                                            rectangle={false}
                                                                            rotate={photo.rotate ? photo.rotate + 'deg' : '0deg'}
                                                                            src={photo.photo}
                                                                            onError={e => {
                                                                                e.target.src = placeholder_image;
                                                                            }}
                                                                        />
                                                                        <ChromeImageParent onClick={() => openGoogleImages(photo.photo)} src={chrome_icon} />
                                                                        <RotatImageIcon
                                                                            src={rotate_right}
                                                                            onClick={() => {
                                                                                profiles[pos].photos[i].rotate = profiles[pos].photos[
                                                                                    i
                                                                                ].rotate
                                                                                    ? profiles[pos].photos[i].rotate + 90
                                                                                    : 90;
                                                                                this.setState({ profiles });
                                                                            }}
                                                                        />

                                                                    </ImageDivFeedParent>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                    <div>
                                                        <GenderView male={profile.gender === 'Male'} />
                                                        <SelectedView
                                                            selected={disapproveProfiles.includes(profile.ref)}
                                                            onClick={() => handleSelectAction(profile.ref)}
                                                        >
                                                            {disapproveProfiles.includes(profile.ref) ? 'X' : ''}
                                                        </SelectedView>
                                                    </div>
                                                    <NameWrapper>
                                                        <CommonTextStyle
                                                            cursor
                                                            highlight
                                                            onClick={() => handleDetailedView(profile.ref)}
                                                        >
                                                            {profile.first_name}
                                                        </CommonTextStyle>
                                                        <CommonTextStyle>{profile.ref}</CommonTextStyle>
                                                    </NameWrapper>
                                                    <BaseButton2
                                                        className={banProfiles.includes(profile.ref) ? 'verifiedBanButtonActive' : 'verifiedBanButtonInactive'}
                                                        onClick={() => handleBanAction(profile.ref)}
                                                    >Ban</BaseButton2>
                                                </ProfileItemWrapper>

                                            );
                                        })}
                                        <GapView height="30px" />
                                        <BottomBarWrapper>
                                            {apiPageChange === 1 ? <img src={previous_inctive} className='cursorPointer marginRight20' /> : <img src={previous_active} className='cursorPointer marginRight20' onClick={() => setApiPageChange(apiPageChange - 1)} />}
                                            {apiPageChange === totalPagesApi.current ? <img src={next_inactive} className='cursorPointer' /> : <img src={next_active} className='cursorPointer' onClick={() => setApiPageChange(apiPageChange + 1)} />}
                                            <BaseButton onClick={() => saveResults()}>Save</BaseButton>
                                        </BottomBarWrapper>
                                    </div>
                                </>
                            ) : <EmptyView />
                        }
                    </>
            }
        </div>
    );
}

export default Verified;